import React from 'react';
import { Box, Typography, Paper } from '@mui/material';

const Alerts = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Alerts Management
      </Typography>
      <Paper sx={{ p: 3 }}>
        <Typography variant="body1" color="text.secondary">
          Alert management interface will be implemented here.
        </Typography>
      </Paper>
    </Box>
  );
};

export default Alerts;
